export interface PublicCredentials {
  password: string;
  scope: PublicScope;
  scopeId: string;
}

export enum PublicScope {
  Survey = "Survey"
}
